import { Base64 } from 'js-base64'
import { mapValues } from 'lodash'
export default class Encoder {
    parseBooleans(filterModel) {
        return mapValues(filterModel, filter => {
            if (filter.filterType !== 'set') {
                return filter
            }
            return {
                ...filter,
                values: filter.values.map(i => {
                    if (i === 'true') {
                        return true
                    }
                    if (i === 'false') {
                        return false
                    }
                    return i
                })
            }
        })
    }
    encode(filterModel) {
        return Base64.encode(JSON.stringify(filterModel))
    }
}

export const encoder = new Encoder()
